import { makeStyles } from '@mui/styles';

const marzipanoStyles = makeStyles(() => ({
    panoWrapper: {
        height: '100%',
    },
}));

export { marzipanoStyles };
